import { apiB2B, apiB2C, apiBase, apiBaseWithBlob } from '../axios-client';
import { ISORISCancelRequest } from '../../models/soris';
import {
  OMS_ORDER_DETAILS_PATH,
  PRINT_RETURN_SHIPPING_LABEL_PATH,
  RETURN_SORIS_CANCEL_PATH,
  OMS_ORDER_DETAILS_LOCAL_DELIVERY_PATH,
  OMS_PTC_DOCUMENTS_PATH,
  OMS_XREF_SEARCH_PATH,
} from '../../constants/paths';
import {
  IOrderDetailsRequest,
  IXrefSearchResponse,
  IXrefSearchRequest,
} from '../../models/order-details';
import { IReturnShippingLabelRequest } from '../../models/returns';
import { IOrderDetailsDownloadRequest } from '../../models/order-details/order-details-page-header';
import {
  IPTCDocumentRequest,
  IPTCDocumentsRequest,
} from '../../models/order-details/ptc-documents';
import { getXClientApp } from '../../utils/channel-helpers';
import { getUserId } from '../../utils/user';

// B2B Order Details Calls

export const GetOrderDetailsAPI = (
  customerType: string,
  customerRole: string,
  requestData: IOrderDetailsRequest,
  channel: 'desktop' | 'tablet' | 'mobile',
  userId: string,
  localDelivery?: boolean,
) => {
  // Always send channel headers since we can't predict if backend will use CPS or LSS
  const headers = {
    channel,
    'X-Client-App': getXClientApp(channel),
  };

  const requestConfig = { headers };

  if (
    customerType === 'b2b' ||
    (customerType === 'b2x' && customerRole !== '')
  ) {
    if (localDelivery) {
      return apiB2B.post(
        OMS_ORDER_DETAILS_LOCAL_DELIVERY_PATH(userId),
        requestData,
        requestConfig,
      );
    }
    return apiB2B.post(
      OMS_ORDER_DETAILS_PATH(userId),
      requestData,
      requestConfig,
    );
  }
  return apiB2C.post(
    OMS_ORDER_DETAILS_PATH(userId),
    requestData,
    requestConfig,
  );
};

export const GetSelectedOrderDetailsAPI = (
  requestData: IOrderDetailsRequest,
  channel: 'desktop' | 'tablet' | 'mobile',
  userId: string,
) => {
  return apiBase.post(OMS_ORDER_DETAILS_PATH(userId), requestData, {
    headers: {
      channel,
      'X-Client-App': getXClientApp(channel),
    },
  });
};

// Returns Calls
export const ReturnShippingLabelAPI = (
  requestData: IReturnShippingLabelRequest,
  userId: string,
  xAuthGuestToken?: string,
) => {
  const headers: { [key: string]: string } = {};
  if (xAuthGuestToken) {
    headers['X-Auth-GuestToken'] = xAuthGuestToken;
  }
  return apiB2B.post(PRINT_RETURN_SHIPPING_LABEL_PATH(userId), requestData, {
    headers,
  });
};

export const GetSORISCancelAPI = (requestData: ISORISCancelRequest) => {
  return apiB2B.post(RETURN_SORIS_CANCEL_PATH, requestData);
};

// Export Order Details Page Information
export const ExportOrderDetails = (
  requestData: IOrderDetailsDownloadRequest,
) => {
  return apiBaseWithBlob.post(
    `${OMS_ORDER_DETAILS_PATH(getUserId() || '')}/export`,
    requestData,
  );
};

/**
 * Bectran API calls
 */
export const GetBectranDocumentsAPI = (request: IPTCDocumentsRequest) => {
  return apiBase.post(OMS_PTC_DOCUMENTS_PATH(getUserId() || ''), request);
};

export const GetSelectedBectranDocumentAPI = (request: IPTCDocumentRequest) => {
  return apiBaseWithBlob.post(
    `${OMS_PTC_DOCUMENTS_PATH(getUserId() || '')}/${
      request.invoiceFileRequest.invoiceType
    }`,
    request,
  );
};

export const getXrefSearchAPI = (request: IXrefSearchRequest) => {
  return apiBase.post<IXrefSearchResponse>(
    OMS_XREF_SEARCH_PATH(getUserId() || ''),
    request,
  );
};
